import { createAsyncType } from '@/store/utils/mutation-types'

export default {
  RESET: 'RESET',
  GET_ITEM: createAsyncType('GET_ITEM'),
  GET_DASHBOARD_LIST: createAsyncType('GET_DASHBOARD_LIST')
}
